import React from 'react';
import PropTypes from 'prop-types';
import './svg.css';


const BuildingIcon = props => {
  const { fill, className } = props;
  return (
    <svg
      viewBox="3 4 20 20"
      height="18px"
      width="18px"
      // className='svg'
    >
      <path d="M6,13.0354507 L12.880262,17.0077718 C12.9543486,17.0505458 13.0320333,17.0814425 13.1111111,17.1010528 L13.1111111,24.8051762 L6.49070127,20.8872047 C6.18655139,20.7072082 6,20.3800352 6,20.0266149 L6,13.0354507 Z M22,12.9298488 L22,20.0266149 C22,20.3800352 21.8134486,20.7072082 21.5092987,20.8872047 L14.8888889,24.8051762 L14.8888889,17.0335592 C14.9050191,17.0255014 14.9210067,17.0169075 14.9368301,17.0077718 L22,12.9298488 Z M14.4700992,7.11738641 L21.4700992,10.8457387 C21.5654307,10.8965144 21.6503066,10.961447 21.7226939,11.0371506 L14.0479413,15.4681711 C13.9974761,15.4973072 13.9509488,15.5306444 13.9085461,15.567486 C13.8661433,15.5306444 13.819616,15.4973072 13.7691509,15.4681711 L6.21611835,11.1074258 C6.30015839,11.0013005 6.40623188,10.9116075 6.5299008,10.8457387 L13.5299008,7.11738641 C13.8237589,6.9608712 14.1762411,6.9608712 14.4700992,7.11738641 Z" id="Combined-Shape" fill={fill ? fill : "#000"}></path>
    </svg>
  );
};

// BuildingIcon.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default BuildingIcon;
